import React from 'react';
import styled from 'App/styled';


interface ShowMoreProps {
  title: string;
  handleClick: () => void;
}
const ShowMoreButton = styled.button`
  ${({ theme }) => theme.typography.buttonMedium};
  margin-left: ${({ theme }) => theme.spacing.spacing60};
  color: ${({ theme }) => theme.colors.primary};
  border: none;
  cursor: pointer;
  text-transform: capitalize;
`;
const ShowMore = ({ title, handleClick }: ShowMoreProps) => (
  <ShowMoreButton onClick={handleClick}>
    {title}
  </ShowMoreButton>
);

export default ShowMore;
